import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { CustomCursor } from "@/components/CustomCursor";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import BlogPage from "@/pages/BlogPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import CertificationsPage from "@/pages/CertificationsPage";
import CareersPage from "@/pages/CareersPage";
import FAQPage from "@/pages/FAQPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import ClientsPage from "@/pages/ClientsPage";
import AlliancePage from "@/pages/AlliancePage";
import PortfolioPage from "@/pages/PortfolioPage";

import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-background">
          {/* Custom Cursor */}
          <CustomCursor />

          {/* Routes */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
            <Route path="/services/:serviceId/:subServiceId" element={<ServiceDetailPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:blogId" element={<BlogDetailPage />} />
            <Route path="/certifications" element={<CertificationsPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/alliances" element={<AlliancePage />} />
          </Routes>

          {/* Toast Notifications */}
          <Toaster position="top-right" richColors />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
